import { ICreateSendContentsAttemptState } from '../types/createSendContentsAttempt';

export const DEFAULT_CREATE_SEND_CONTENTS_ATTEMPT_STATE: ICreateSendContentsAttemptState = {
  attemptedUnsetKey: null,
  highlightGeneration: 0,
};
